 export class Player {
    constructor(username, profileAvatar, health, commanderDamage, poisonCount, deck) {
        this.username = username;
        this.profileAvatar = profileAvatar;
        this.health = health;
        this.commanderDamage = commanderDamage;
        this.poisonCount = poisonCount;
        this.deck = deck;
    }
 }